<div class="trigger" #trigger
     [colorPicker]="color"
     [cpAlphaChannel]="'always'"
     [cpOutputFormat]="'hex'"
     (colorPickerChange)="emitSelectedEvent($event)"
     [cpDialogDisplay]="'inline'"
     [cpToggle]="false"
></div>